var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('the-slider'),_c('the-services'),_c('the-offers'),_c('the-map-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }